// Valenoq — scripts propios (vanilla JS, un solo archivo, defer)
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vq-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vq-visible'); });
      return;
    }
    document.querySelectorAll('.vq-stagger').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--vq-i', i);
      });
    });
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vq-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.vq-count[data-target]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          var target = parseFloat(el.getAttribute('data-target')) || 0;
          var decimals = (el.getAttribute('data-target').split('.')[1] || '').length;
          if (reduceMotion) {
            el.textContent = target.toFixed(decimals);
            return;
          }
          var start = null;
          var duration = 1400;
          function step(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (target * eased).toFixed(decimals);
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  // La "foto principal" ahora vive dentro del carrusel de demostracion (su
  // diapositiva activa) cuando existe; si no hay carrusel, cae en el viejo
  // elemento [data-vq-galeria-principal]. Los miniaturas y el cambio de color
  // de variante comparten esta misma funcion para no duplicar logica.
  function actualizarFotoPrincipal(src, alt) {
    if (!src) return;
    var demo = document.querySelector('[data-vq-demo]');
    var activo = demo
      ? demo.querySelector('.vq-demo__slide.is-active img')
      : document.querySelector('[data-vq-galeria-principal]');
    if (!activo) return;
    activo.src = src;
    if (alt) activo.alt = alt;
    var leyenda = demo ? demo.querySelector('[data-vq-demo-leyenda]') : null;
    if (leyenda && alt) leyenda.textContent = alt;
    if (demo && demo.__vqPausar) demo.__vqPausar();
  }

  function initGaleria() {
    document.querySelectorAll('[data-vq-galeria]').forEach(function (galeria) {
      var thumbs = galeria.querySelectorAll('[data-vq-galeria-thumb]');
      if (!thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          actualizarFotoPrincipal(thumb.getAttribute('data-full'), thumb.getAttribute('data-full-alt'));
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-vq-producto-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-vq-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var selects = form.querySelectorAll('[data-vq-opcion]');
      var idInput = form.querySelector('input[name="id"]');
      var precioCompareEl = form.querySelector('[data-vq-precio-comparado]');
      var botonEl = form.querySelector('[data-vq-boton-comprar]');
      var textoAgotado = form.getAttribute('data-texto-agotado') || 'Agotado';
      var textoComprar = form.getAttribute('data-texto-comprar') || 'Añadir al carrito';
      var fotoTiersDefecto = null;
      var fotosTiers = form.querySelectorAll('.vq-tiers__foto');
      if (fotosTiers.length) fotoTiersDefecto = fotosTiers[0].getAttribute('src');

      function moneda(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        });
      }

      function actualizar() {
        var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        // Actualiza el precio en el formulario y tambien en cualquier otro
        // sitio de la pagina que lo repita (p. ej. la barra de compra fija).
        document.querySelectorAll('[data-vq-precio]').forEach(function (el) {
          el.textContent = moneda(match.price);
        });
        if (precioCompareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            precioCompareEl.textContent = moneda(match.compare_at_price);
            precioCompareEl.style.display = '';
          } else {
            precioCompareEl.style.display = 'none';
          }
        }
        // Si esta variante tiene su propia foto, cambia la imagen principal
        // de la galeria para que se vea el color elegido.
        if (match.image) {
          actualizarFotoPrincipal(match.image, match.image_alt);
        }
        // Las miniaturas de las tarjetas Simple/Dúo/Trío también deben
        // reflejar el color elegido, no solo la cantidad de unidades. Se
        // busca la foto de CUALQUIER variante de ese mismo color (aunque no
        // sea la seleccionada) porque los packs Dúo/Trío no tienen foto
        // propia — todos comparten la del color base.
        if (fotosTiers.length) {
          var colorElegido = seleccion[0];
          var variantesDeEseColor = variantes.filter(function (v) { return v.options[0] === colorElegido; });
          var varianteConFoto = variantesDeEseColor.find(function (v) { return v.image; });
          var fotoTiers = varianteConFoto ? varianteConFoto.image : fotoTiersDefecto;
          if (fotoTiers) {
            fotosTiers.forEach(function (img) { img.setAttribute('src', fotoTiers); });
          }
        }
        if (botonEl) {
          botonEl.disabled = !match.available;
          botonEl.textContent = match.available ? textoComprar : textoAgotado;
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  function initComparador() {
    document.querySelectorAll('[data-vq-comparador]').forEach(function (comp) {
      var handle = comp.querySelector('[data-vq-comparador-handle]');
      var after = comp.querySelector('[data-vq-comparador-after]');
      if (!handle || !after) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = comp.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }

      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointerup', function () { dragging = false; });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      comp.addEventListener('click', function (e) {
        if (e.target === handle) return;
        setPos(e.clientX);
      });
    });
  }

  function initDemo() {
    document.querySelectorAll('[data-vq-demo]').forEach(function (demo) {
      var slides = demo.querySelectorAll('[data-vq-demo-slide]');
      var puntos = demo.querySelectorAll('[data-vq-demo-punto]');
      var leyenda = demo.querySelector('[data-vq-demo-leyenda]');
      if (!slides.length) return;
      var segundos = parseFloat(demo.getAttribute('data-velocidad')) || 3;
      var indice = 0;
      var timer = null;

      function irA(i) {
        indice = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === indice); });
        puntos.forEach(function (p, n) { p.classList.toggle('is-active', n === indice); });
        if (leyenda) {
          var img = slides[indice].querySelector('img');
          leyenda.textContent = img ? img.getAttribute('alt') : '';
        }
      }

      function iniciar() {
        detener();
        if (reduceMotion) return;
        timer = setInterval(function () { irA(indice + 1); }, segundos * 1000);
      }
      function detener() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      // Permite que otras funciones (miniaturas, cambio de color) pausen el
      // avance automatico cuando fuerzan una foto concreta en pantalla.
      demo.__vqPausar = detener;

      puntos.forEach(function (p, n) {
        p.addEventListener('click', function () {
          irA(n);
          iniciar();
        });
      });

      demo.addEventListener('mouseenter', detener);
      demo.addEventListener('mouseleave', iniciar);
      demo.addEventListener('focusin', detener);
      demo.addEventListener('focusout', iniciar);

      irA(0);
      iniciar();
    });
  }

  function initBarraFija() {
    var barra = document.querySelector('[data-vq-barra-fija]');
    var original = document.querySelector('[data-vq-boton-comprar]');
    if (!barra || !original || !('IntersectionObserver' in window)) return;

    var boton = barra.querySelector('[data-vq-barra-fija-boton]');
    if (boton) {
      boton.addEventListener('click', function () {
        original.click();
      });
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Se muestra solo cuando el boton original ya quedo por ENCIMA de
          // la pantalla (el usuario ha bajado mas alla de el), nunca antes.
          var pasado = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
          barra.classList.toggle('is-visible', pasado);
        });
      },
      { threshold: 0 }
    );
    io.observe(original);
  }

  function initResenaMini() {
    document.querySelectorAll('[data-vq-resena-mini]').forEach(function (contenedor) {
      var paginas = contenedor.querySelectorAll('[data-vq-resena-mini-pagina]');
      if (paginas.length < 2 || reduceMotion) return;
      var segundos = parseFloat(contenedor.getAttribute('data-velocidad')) || 4;
      var indice = 0;
      setInterval(function () {
        paginas[indice].classList.remove('is-active');
        indice = (indice + 1) % paginas.length;
        paginas[indice].classList.add('is-active');
      }, segundos * 1000);
    });
  }

  // El formulario de compra de la ficha de producto es propio (no el
  // <product-form> nativo de Dawn), así que se encarga él mismo de mandar el
  // producto al carrito por AJAX y abrir el carrito lateral, en vez de hacer
  // un envío de formulario normal (que recargaría la página entera).
  function initEnvioCarrito() {
    document.querySelectorAll('[data-vq-producto-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // Cerrojo por si el envío se dispara dos veces (doble clic, la barra
        // fija y el botón normal a la vez, doble "submit"...). Sin esto,
        // /cart/add.js SUMA sobre lo que ya hay en el carrito en vez de fijar
        // la cantidad elegida — así es como "1 bolsa" acababa saliendo como
        // Pack Dúo, o el Pack Dúo como el doble.
        if (form.dataset.enviando === 'true') return;
        form.dataset.enviando = 'true';

        var boton = form.querySelector('[data-vq-boton-comprar]');
        var textoOriginal = boton ? boton.textContent : '';
        if (boton) {
          boton.disabled = true;
          boton.textContent = 'Añadiendo…';
        }

        function restaurar() {
          form.dataset.enviando = 'false';
          if (boton) {
            boton.disabled = false;
            boton.textContent = textoOriginal;
          }
        }

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var cantidadDeseada = parseInt(formData.get('quantity'), 10) || 1;

        // La bolsa elegida (color) puede ya estar en el carrito de una visita
        // o clic anterior. En ese caso fijamos la cantidad exacta con
        // /cart/change.js en vez de sumar más encima con /cart/add.js.
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var yaEnCarrito = (cart.items || []).find(function (it) {
              return String(it.variant_id) === String(variantId);
            });
            if (yaEnCarrito) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: cantidadDeseada })
              });
            }
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              restaurar();
              return;
            }
            try { sessionStorage.setItem('vq-abrir-carrito', '1'); } catch (err) {}
            window.location.reload();
          })
          .catch(restaurar);
      });
    });
  }

  function initHeroRotador() {
    document.querySelectorAll('[data-vq-hero-rotador]').forEach(function (contenedor) {
      var fotos = contenedor.querySelectorAll('.vq-hero__spotlight-foto');
      if (fotos.length < 2 || reduceMotion) return;
      var segundos = parseFloat(contenedor.getAttribute('data-velocidad')) || 4;
      var indice = 0;
      setInterval(function () {
        fotos[indice].classList.remove('is-active');
        indice = (indice + 1) % fotos.length;
        fotos[indice].classList.add('is-active');
      }, segundos * 1000);
    });
  }

  function initTiers() {
    document.querySelectorAll('[data-vq-tiers]').forEach(function (contenedor) {
      var select = contenedor.parentElement.querySelector('[data-vq-tier-select]');
      var cartas = contenedor.querySelectorAll('[data-vq-tier-card]');
      if (!select || !cartas.length) return;
      cartas.forEach(function (carta) {
        carta.addEventListener('click', function () {
          select.value = carta.getAttribute('data-valor');
          select.dispatchEvent(new Event('change', { bubbles: true }));
          cartas.forEach(function (c) { c.classList.remove('is-active'); });
          carta.classList.add('is-active');
        });
      });
    });
  }

  function initCarritoVideos() {
    var botones = [].slice.call(document.querySelectorAll('.vq-carrito-videos__item'));
    if (!botones.length) return;
    var videos = botones.map(function (b) { return b.querySelector('video'); });

    // En escritorio los 3 se reproducen solos a la vez. En móvil (por CSS) solo
    // se muestra el primero, que sí autoreproduce sin problema. Solo pausamos
    // los demás cuando el usuario toca uno a mano.
    function pausarOtros(actual) {
      videos.forEach(function (v) {
        if (v && v !== actual && !v.paused) { try { v.pause(); } catch (e) {} }
      });
    }

    botones.forEach(function (boton, i) {
      var video = videos[i];
      if (!video) return;

      video.addEventListener('playing', function () { boton.setAttribute('data-vq-reproduciendo', 'true'); });
      video.addEventListener('pause', function () { boton.removeAttribute('data-vq-reproduciendo'); });

      boton.addEventListener('click', function () {
        if (video.paused) {
          pausarOtros(video);
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        } else {
          video.pause();
        }
      });

      // Fuerza el autoplay al cargar y también si el navegador lo pausó al
      // volver a la pestaña o al terminar de descargar el vídeo.
      var intentar = function () {
        if (!video.paused) return;
        var p = video.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      };
      intentar();
      video.addEventListener('canplay', intentar);
      video.addEventListener('loadeddata', intentar);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        videos.forEach(function (v) {
          if (v && v.paused && v.closest('.vq-carrito-videos__item') && getComputedStyle(v).display !== 'none') {
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          }
        });
      }
    });
  }

  function initMarquee() {
    document.querySelectorAll('[data-vq-marquee-track]').forEach(function (track) {
      if (track.dataset.duplicated) return;
      track.innerHTML += track.innerHTML;
      track.dataset.duplicated = 'true';
      var speed = parseFloat(track.getAttribute('data-speed')) || 40;
      track.style.animationDuration = speed + 's';
    });
  }

  // Botón "Copiar" del código de bienvenida en el carrito (delegación en
  // document para sobrevivir a los re-render del drawer).
  function initCodigoDescuento() {
    if (window.__vqCodigoDescInit) return;
    window.__vqCodigoDescInit = true;

    var ocupado = false;

    function setDiscount(code) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (r) { return r.json(); });
    }

    // Tras aplicar el código, el carrito lateral se vuelve a pintar sin recargar
    // la página (así el cliente no pierde el carrito abierto). En la página del
    // carrito, o si algo falla, se recarga como antes.
    function refrescar() {
      var drawer = document.querySelector('#CartDrawer');
      var paginaCarrito = document.querySelector('#main-cart-items, cart-items.cart__items');
      if (!drawer || paginaCarrito) { window.location.reload(); return; }
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var nuevo = doc.querySelector('#CartDrawer');
          if (!nuevo) throw new Error('sin drawer');
          drawer.innerHTML = nuevo.innerHTML;
          var burbuja = document.getElementById('cart-icon-bubble');
          if (burbuja && s['cart-icon-bubble']) {
            var d2 = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (d2) burbuja.innerHTML = d2.innerHTML;
          }
          ocupado = false;
        })
        .catch(function () { window.location.reload(); });
    }

    // Shopify no refleja los códigos en el total del carrito/drawer hasta que
    // la página se vuelve a renderizar. Por eso, tras aplicar el código,
    // recargamos una vez: es lo único que garantiza que el total que se ve
    // coincida con el real. En la recarga volvemos a preguntar al carrito
    // (no a un atributo de Liquid) si ya está aplicado, así que no se repite.
    function aplicar() {
      if (ocupado) return;
      var box = document.querySelector('[data-vq-codigo-autoaplicar]');
      var limpiar = document.querySelector('[data-vq-codigo-limpiar]');

      // Carrito tipo Pack Dúo: el descuento del pack ya se ve bien solo (es
      // automático). Aquí solo retiramos el código sobrante para que no dé
      // error en el pago; no hace falta recargar, no cambia ningún total.
      if (limpiar && !box) {
        if (limpiar.getAttribute('data-vq-codigo-hecho') === 'true') return;
        ocupado = true;
        setDiscount('').catch(function () {}).then(function () {
          limpiar.setAttribute('data-vq-codigo-hecho', 'true');
          ocupado = false;
        });
        return;
      }

      if (!box) return;
      var code = box.getAttribute('data-vq-codigo-autoaplicar');
      if (!code) return;
      ocupado = true;
      // No nos fiamos de si Liquid ya lo marcó como "listo" (a veces no
      // coincide con el estado real del carrito) — preguntamos directamente
      // al carrito, que es la fuente de verdad.
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var yaAplicado = cart && cart.discount_codes && cart.discount_codes.some(function (d) {
            return d.code === code && d.applicable;
          });
          if (yaAplicado) {
            box.classList.add('is-aplicado');
            ocupado = false;
            return;
          }
          return setDiscount(code).then(function (cart2) {
            var ok = cart2 && cart2.discount_codes && cart2.discount_codes.some(function (d) {
              return d.code === code && d.applicable;
            });
            if (ok) { refrescar(); return; }
            ocupado = false;
          });
        })
        .catch(function () { ocupado = false; });
    }

    // "Añadir 1 más": pasa de 1 a 2 unidades para que entre el descuento de pack.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vq-pack-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: 1, quantity: 2 })
      }).then(function () { window.location.reload(); })
        .catch(function () { btn.disabled = false; });
    });

    aplicar();
    // Dawn avisa con su propio evento cuando se añade algo al carrito (botón
    // "Añadir al carrito" de la ficha): ahí hay que aplicar el código también.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(aplicar, 700); });
    }
    // Reintentar cuando el carrito cambia o se abre el drawer.
    ['cart:refresh', 'cart:updated', 'cart:open', 'cart-drawer:open'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(aplicar, 80); });
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('a[href$="/cart"], [data-vq-cart-toggle], .header__icon--cart');
      if (t) setTimeout(aplicar, 150);
    });
  }

  // Selector "1 bolsa / Pack Dúo": al tocar una tarjeta cambia la cantidad
  // que se añade al carrito (1 o 2). El descuento de las 2 unidades lo aplica
  // Shopify solo en el carrito.
  function initPackSelector() {
    document.querySelectorAll('[data-vq-pack]').forEach(function (pack) {
      var qtyInput = pack.querySelector('[data-vq-pack-qty]');
      var cards = [].slice.call(pack.querySelectorAll('[data-vq-pack-card]'));
      if (!qtyInput || !cards.length) return;
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) { c.classList.remove('is-active'); });
          card.classList.add('is-active');
          qtyInput.value = card.getAttribute('data-qty') || '1';
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initDemo();
    initGaleria();
    initVariantes();
    initComparador();
    initBarraFija();
    initResenaMini();
    initHeroRotador();
    initEnvioCarrito();
    initTiers();
    initPackSelector();
    initCodigoDescuento();
    initMarquee();
    initCarritoVideos();
  });
})();
